import React from "react";
import { Grid } from "@material-ui/core";
import Select from "react-select";

const ModalSelect = ({
  label,
  options,
  defaultValue = "",
  onChange,
  isLoading = false,
  width = "",
  isClearable = true,
  value,
  sm = 2
}) => {
  return (
    <Grid container style={{ marginTop: 20 }}>
      <Grid
        item
        sm={sm}
        style={{
          textAlign: "start",
          marginRight: 20,
          display: "flex",
          alignItems: "center",
        }}
      >
        <label>{label}:</label>
      </Grid>
      <Grid item style={{ flexGrow: 1, width: width === "" ? "" : width }}>
        <Select
          className="select-modal-container"
          classNamePrefix="select-modal"
          options={options}
          isClearable={isClearable}
          defaultValue={defaultValue}
          onChange={(event) => onChange(event)}
          onKeyDown={(event) => {
            event.stopPropagation();
          }}
          isLoading={isLoading}
          value={value}
          styles={{
            menu: (styles) => ({
              ...styles,
              zIndex: 999,
            }),
            indicatorsContainer: (styles) => ({
              ...styles,
            }),
          }}
        />
      </Grid>
    </Grid>
  );
};

export default ModalSelect;
